import React from 'react';
import PropTypes from 'prop-types';
import { Field, Fields, FieldArray } from 'redux-form';

import { featureTypesType, entityType } from 'types';
import Toggler from 'components/Toggler';
import { FormLabel } from 'components/Form';

import FormNamedColorPalette from 'components/Form/components/FormNamedColorPalette';
import Features from './Features';

import './style.scss';

const EntityInspectGeneral = ({
  isDisabled,
  featureTypes,
  currentEntity,
  onToggle,
  handlersOfNameInputRef,
}) => (
  <div styleName="entity">
    <FormLabel htmlFor="name">ENTITY NAME</FormLabel>
    <div styleName="infos" data-test="main-info">
      <Fields
        names={['color', 'name']}
        component={FormNamedColorPalette}
        isDisabled={isDisabled}
        placeholder="Please type a name for the entity"
        styleName="color-picker-field"
        handlersOfNameInputRef={handlersOfNameInputRef}
        autoFocus
      />

      <Field
        name="multi_value"
        label="Multi-value"
        styleName="toggler"
        isDisabled={isDisabled}
        component={Toggler}
      />

      <Field
        name="public"
        label="Public"
        styleName="toggler"
        isDisabled={isDisabled}
        component={Toggler}
        onToggle={onToggle}
      />
    </div>
    <FieldArray
      name="features"
      featureTypes={featureTypes}
      component={Features}
      currentEntity={currentEntity}
    />
  </div>
);

EntityInspectGeneral.propTypes = {
  isDisabled: PropTypes.bool,
  currentEntity: entityType,
  featureTypes: PropTypes.arrayOf(featureTypesType).isRequired,
  onToggle: PropTypes.func,
  handlersOfNameInputRef: PropTypes.arrayOf(PropTypes.func),
};

EntityInspectGeneral.defaultProps = {
  handlersOfNameInputRef: [],
};

export default EntityInspectGeneral;
